import { createAction, handleActions } from 'redux-actions';
import { database } from '../../firebase';

export const placementsRef = database.ref('/instances');

export enum ACTION_TYPES {
  INSERT_PLACEMENTS = '@DONACO/INSERT_PLACEMENTS',
  FILTER_BY_STATUS = '@DONACO/FILTER_BY_STATUS',
  FILTER_BY_URL = '@DONACO/FILTER_BY_URL',
  CURRENTLY_EDITING_PLACEMENT = '@DONACO/CURRENTLY_EDITING_PLACEMENT',
  SAVING_PLACEMENT = '@DONACO/SAVING_PLACEMENT',
  SAVED_PLACEMENT = '@DONACO/SAVED_PLACEMENT',
  CLEAR_SAVED_PLACEMENT = '@DONACO/CLEAR_SAVED_PLACEMENT',
  CLEAR_CURRENTLY_EDITING_PLACEMENT = '@DONACO/CLEAR_CURRENTLY_EDITING_PLACEMENT',
}

export interface PlacementData {
  active: boolean;
  charities: Array<any>;
  createdAt: string;
  url: string;
}

export interface PlacementState {
  all: Array<PlacementData>;
  currentlyEditingPlacement: PlacementData;
  saving: boolean;
  statusFilter: boolean;
  urlFilter: string;
  saved: boolean;
}

const defaultState: PlacementState = {
  all: [],
  currentlyEditingPlacement: null,
  saving: false,
  saved: false,
  urlFilter: '',
  statusFilter: false
};

export const placementsReducer = handleActions({
  [ ACTION_TYPES.INSERT_PLACEMENTS ]: (state, action) => {
    return {
      ...state,
      all: action.payload
    };
  },
  [ ACTION_TYPES.FILTER_BY_STATUS ]: (state, action) => {
    return {
      ...state,
      statusFilter: action.payload
    };
  },
  [ ACTION_TYPES.FILTER_BY_URL ]: (state, action) => {
    return {
      ...state,
      urlFilter: action.payload
    };
  },
  [ ACTION_TYPES.CURRENTLY_EDITING_PLACEMENT ]: (state, action) => {
    const currentlyEditingPlacement: any = action.payload;
    return {
      ...state,
      currentlyEditingPlacement: {
        ...currentlyEditingPlacement,
        ...currentlyEditingPlacement.charities
      }
    };
  },
  [ ACTION_TYPES.SAVING_PLACEMENT ]: (state, action) => {
    return {
      ...state,
      saving: true
    };
  },
  [ ACTION_TYPES.SAVED_PLACEMENT ]: (state, action) => {
    return {
      ...state,
      saving: false,
      saved: true
    };
  },
  [ ACTION_TYPES.CLEAR_CURRENTLY_EDITING_PLACEMENT ]: (state, action) => {
    return {
      ...state,
      currentlyEditingPlacement: null,
    };
  },
  [ ACTION_TYPES.CLEAR_SAVED_PLACEMENT ]: (state, action) => {
    return {
      ...state,
      saved: false
    };
  }
} as any, defaultState);

const insertPlacementsAction = createAction(ACTION_TYPES.INSERT_PLACEMENTS, (payload) => payload);
export const placementCurrentlyEditingAction = createAction(ACTION_TYPES.CURRENTLY_EDITING_PLACEMENT, (payload) => payload);
export const clearCurrentlyEditingPlacementAction = createAction(ACTION_TYPES.CLEAR_CURRENTLY_EDITING_PLACEMENT);
export const savingPlacementAction = createAction(ACTION_TYPES.SAVING_PLACEMENT);
export const savedPlacementAction = createAction(ACTION_TYPES.SAVED_PLACEMENT);
export const clearSavedPlacementAction = createAction(ACTION_TYPES.CLEAR_SAVED_PLACEMENT);
export const filterByStatusAction = createAction(ACTION_TYPES.FILTER_BY_STATUS, (payload) => payload);
export const filterByUrlAction = createAction(ACTION_TYPES.FILTER_BY_URL, (payload) => payload);

export const togglePlacementStatus = (uid: string, placement: PlacementData) => {
  return (dispatch) => {
    dispatch(togglePlacementStatusFromFirebase(uid, placement));
  };
};

export const togglePlacementStatusFromFirebase = (uid: string, placement: PlacementData) => {
  return (dispatch) => {
    placementsRef
      .child(uid)
      .update(placement);
  };
};

export const startListeningForPlacements = () => {
  return (dispatch) => {
    placementsRef.on('value', (snapshot) => {
      const placements = snapshot.val();
      dispatch(insertPlacementsAction(placements));
    });
  };
};
